import React from 'react';
import { Box } from '@mui/material';
import { documentAuthLogoSx } from '../constants/documentTheme';
import { MEMORIES_BRAND } from '../constants/memoriesBrand';

const partnerLogoSx = {
  ...documentAuthLogoSx,
  width: 'auto',
  maxWidth: 168,
  height: 44,
  objectFit: 'contain',
  border: 0,
};

const AuthPageBrandMark = ({ brandName, brandLogoUrl, memories = false }) => {
  if (brandLogoUrl) {
    return (
      <Box
        component="img"
        src={brandLogoUrl}
        alt={brandName || ''}
        sx={partnerLogoSx}
      />
    );
  }
  if (brandName) return null;
  return (
    <Box
      component="img"
      src={memories ? MEMORIES_BRAND.appiconLight : '/symbol.svg'}
      alt=""
      sx={documentAuthLogoSx}
    />
  );
};

export default AuthPageBrandMark;
